import Logo from "@/components/Logo";
import { useSettings } from "@/lib/settings";
import { useI18n } from "@/lib/i18n";
import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  const { settings } = useSettings();
  const { t } = useI18n();
  return (
    <footer className="bg-[#0a1e3f] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div>
          <Logo variant="light" />
          <p className="mt-4 text-sm text-white/70 leading-relaxed">{t("ft_desc")}</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#d4a437] font-bold mb-4">{t("ft_navigation")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="hover:text-[#d4a437]">{t("nav_vehicles")}</Link></li>
            <li><Link to="/how-it-works" className="hover:text-[#d4a437]">{t("nav_how")}</Link></li>
            <li><Link to="/about" className="hover:text-[#d4a437]">{t("nav_about")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#d4a437]">{t("nav_contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#d4a437] font-bold mb-4">{t("ft_partners")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-[#d4a437]">{t("ft_become_partner")}</Link></li>
            <li><Link to="/login" className="hover:text-[#d4a437]">{t("ft_agency_space")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#d4a437] font-bold mb-4">Légal</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="ft-legal-cgu" to="/legal/cgu" className="hover:text-[#d4a437]">CGU</Link></li>
            <li><Link data-testid="ft-legal-privacy" to="/legal/privacy" className="hover:text-[#d4a437]">Confidentialité</Link></li>
            <li><Link data-testid="ft-legal-mentions" to="/legal/mentions" className="hover:text-[#d4a437]">Mentions légales</Link></li>
            <li><Link data-testid="ft-legal-cookies" to="/legal/cookies" className="hover:text-[#d4a437]">Cookies</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#d4a437] font-bold mb-4">{t("ft_contact")}</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-[#d4a437]" /> {settings.contact_email}</li>
            {settings.contact_phone && <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-[#d4a437]" /> {settings.contact_phone}</li>}
            {settings.address && <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[#d4a437]" /> {settings.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/60">
        © {new Date().getFullYear()} {settings.site_name || "MOBIKAR"}. {t("ft_rights")}
      </div>
    </footer>
  );
}
